export const LayoutActionTypes = {
  HANDLE_THEME: 'HANDLE_THEME'
};

export const ModalActionTypes = {
  HANDLE_MODAL: 'HANDLE_MODAL',
  HANDLE_MODAL_REGISTER: 'HANDLE_MODAL_REGISTER',
  HANDLE_MODAL_LOGIN: 'HANDLE_MODAL_LOGIN',
  HANDLE_MODAL_CHECK_EMAIL: 'HANDLE_MODAL_CHECK_EMAIL',
  HANDLE_MODAL_ACCOUNT_VERIFIED: 'HANDLE_MODAL_ACCOUNT_VERIFIED',
  HANDLE_MODAL_PURCHASE_SUMMARY: 'HANDLE_MODAL_PURCHASE_SUMMARY',
  HANDLE_MODAL_PURCHASE_SUCCESS: 'HANDLE_MODAL_PURCHASE_SUCCESS',
  HANDLE_MODAL_PURCHASE_ERROR: 'HANDLE_MODAL_PURCHASE_ERROR'
};
